import { types } from 'mobx-state-tree';
export const StructureModel = types.model({
    id: types.identifier,
    structure: types.model({
        pdb: types.string,
        startPos: types.number,
        endPos: types.number,
    }),
    range: types.maybe(types.string),
});
//# sourceMappingURL=StructureModel.js.map